import clsx from "clsx";
import type { Brand } from "@/shared/lib/brand";
import { Wordmark } from "./Wordmark";

/** The workspace's mark where ClientOS's goes: its logo, or its name without one, when it's white label. */
export function BrandMark({ brand, className, large }: { brand: Brand | null | undefined; className?: string; large?: boolean }) {
  if (!brand) return <Wordmark className={className} />;
  if (brand.logo) return <img src={brand.logo} alt={brand.name} className={clsx("w-auto object-contain", large ? "h-12 max-w-[220px]" : "h-8 max-w-[160px]")} />;
  return <span className={clsx("block truncate font-bold text-ink", large ? "text-[19px]" : "text-[15px]")}>{brand.name}</span>;
}

/** The mark of the folded sidebar: the logo, or the name's first letter. */
export function BrandIcon({ brand }: { brand: Brand | null | undefined }) {
  if (!brand) return <img src="/favicon.svg" alt="ClientOS" className="size-7" />;
  if (brand.logo) return <img src={brand.logo} alt={brand.name} className="size-8 object-contain" />;
  return <span aria-label={brand.name} className="grid size-8 place-items-center rounded-md bg-ledger font-bold text-white">{[...brand.name][0]}</span>;
}
